export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const SET_SUCCESS = "SET_SUCCESS";
export const SET_ERROR = "SET_ERROR";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const SET_PARAMS = "SET_PARAMS";
export const SET_MESSAGE_CODE = "SET_MESSAGE_CODE";
